var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-wrapper"},[_c('button',{staticClass:"btn btn-sm btn-light",on:{"click":function($event){return _vm.download()}}},[_c('a-icon',{attrs:{"type":"paper-clip"}}),_vm._v(" "+_vm._s(_vm.getSubString(_vm.localFileName))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }